export default "__VITE_ASSET__Ccu6KCQU__"